// extracted by mini-css-extract-plugin
export var textInput = "_cf-0";